module.exports = __webpack_public_path__ + "img/banknote.d3d1b8e7.svg";